import Param from '../../param';
import effectManager from '../effect';
import AnimationMnager from '../animation';

const param = new Param();
const effect = new effectManager();
const animation = new AnimationMnager();


export default class ModalClose{
    constructor($container,$bg){
        this.$container = $container;
        this.$bg = $bg;
    }
    start(){
        let _this = this;


        effect.show(_this.$container.find(".modal-cnt.is-current .p-column-illust >*"),"out");
        effect.show(_this.$container.find("#p-column-modal-body-ctrl-next,#p-column-modal-body-ctrl-prev,#p-column-modal-close"),"out");
        effect.splitText($(".modal-cnt.is-current .number >* >*,.modal-cnt.is-current .title >* >*"),"out");
        effect.show(_this.$container.find(".modal-cnt.is-current .text"),"out");
        effect.show(_this.$container.find("#p-column-modal-body-page"),"out");

        setTimeout(function(){
            TweenMax.to(_this.$bg,0.7,{
                // scale : 1,
                opacity:1,
                ease: Power2.easeIn,
                onComplete:function(){
                    TweenMax.to($("#p-column-list .js__modal-trigger"),0.4,{
                        scale : 1,
                        // ease: Bounce.easeIn
                        ease: Power2.easeOut,
                    });
                    _this.$container.removeClass("is-active");

                    TweenMax.to($("#l-pager-trigger"),0.4,{ x : 0 });

                }
            });

        },5e2);



        // console.log(animation.svgPathMorph);

        setTimeout(function(){
            // animation.svgPathMorph($("#svg-modal-bg-start"),["#svg-modal-bg-end"],"normal",1.2);
        },2e2);

    }
}